import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './button.module.scss';

const styles = pickCss(css, css.root);

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'outline'
  | 'ghost'
  | 'link'
  | 'destructive'
  | 'success'
  | 'dark'
  | 'light';

type ButtonSize = 'sm' | 'default' | 'lg' | 'xl' | 'icon' | 'iconSm';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: ReactNode;
  // React 19 — refs flow through as a regular prop. Forwarded so callers
  // can grab the element for setPointerCapture / focus management without
  // dropping back to a raw <button>.
  ref?: Ref<HTMLButtonElement>;
};

export const Button = ({
  variant = 'primary',
  size = 'default',
  icon,
  className,
  disabled,
  children,
  ref,
  ...restProps
}: ButtonProps) => (
  <button
    className={styles({ variant, size, isDisabled: !!disabled }, className)}
    disabled={disabled}
    ref={ref}
    {...restProps}
  >
    {icon}
    {children}
  </button>
);
